import { newE2EPage } from '@stencil/core/testing';

describe('hr-widget', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<hr-widget></hr-widget>');

    const element = await page.find('hr-widget');
    expect(element).toHaveClass('hydrated');
  });
});
